import React from 'react'
import PropTypes from 'prop-types'

import CocktailThumbnail from './CocktailThumbnail'

import '../styles/components/cocktailList.scss'

const CocktailList = ({ cocktails }) => {
  if (cocktails.length === 0) {
    return <div className="cocktail-list">No result</div>
  }
  return (
    <div className="cocktail-list">
      {cocktails.map((cocktail) => (
        <CocktailThumbnail
          key={cocktail._id}
          id={cocktail._id}
          imageFileName={cocktail.imageFileName}
          name={cocktail.name}
          description={cocktail.description}
        />
      ))}
    </div>
  )
}

CocktailList.propTypes = {
  cocktails: PropTypes.array.isRequired,
}

export default CocktailList
